// extracted by mini-css-extract-plugin
module.exports = {"crossLink":"CrossLink_crossLink__OH1_N","header":"CrossLink_header__opkEd","reverse":"CrossLink_reverse__CVtKH","icon":"CrossLink_icon__Tm_uZ","content":"CrossLink_content__AuXgK"};